// extracted by mini-css-extract-plugin
export var completionBody = "_c2-2";
export var completionCard = "_c2-0";
export var completionFooter = "_c2-3";
export var completionTitle = "_c2-1";